import { Ref, useEffect } from 'react';

/**
 * A custom hook to attach and clean up scroll and touchmove event listeners
 * @param {React.RefObject} scrollRef - The ref to the container element to attach listeners to
 * @param {Function} onHandleContainerScroll - The function to handle the scroll event
 */
export function useScrollRefEventListener({
  scrollRef,
  onHandleContainerScroll,
}: {
  scrollRef?: Ref<HTMLDivElement>;
  onHandleContainerScroll: () => void;
}) {
  useEffect(() => {
    if (scrollRef && 'current' in scrollRef) {
      const currentScrollRef = scrollRef.current;

      currentScrollRef?.addEventListener('touchmove', onHandleContainerScroll);
      currentScrollRef?.addEventListener('scroll', onHandleContainerScroll);

      return () => {
        currentScrollRef?.removeEventListener('touchmove', onHandleContainerScroll);

        currentScrollRef?.removeEventListener('scroll', onHandleContainerScroll);
      };
    }

    return undefined;
  }, [scrollRef, onHandleContainerScroll]);
}
